<!-- Authord.by.KWShin.2024.09.26. -->
<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    sstmId: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('common/system', ['getSystemById']),
    dbType() {
      return this.getSystemById(this.sstmId).database.type;
    },
    title() {
      return this.$t('dv.title.exc');
    },
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'digit',
      },
    };
  },
  methods: {
    setData(dataList) {
      // HANA와 ORA의 경우 계산 방식이 동일하지만,
      // 계산 방식이 달라질 경우를 고려하여 구조를 남겨 둚.
      if (this.dbType == 'HANA') {
        if (dataList.length > 0) {
          this.data.value = dataList.length;
        } else this.data.value = 0;
      } else {
        if (dataList.length > 0) {
          this.data.value = dataList.length;
        } else this.data.value = 0;
      }
    },
  },
};
</script>
